import styled from "styled-components";


export const Wrapper = styled.div` 
    padding:30px;
    background-color:#ceebee;
    h1{
        color: #008ba1!important;
        text-align: left;
        
    }
    .txtcss{
        color: #4f646d!important;
        text-align:left;
        font-size: 12px;
        font-weight: 300;
    }
    .wrap{
        background-color:#ffffff;
        // border: 1px solid #8accd6;
        padding: 70px;
        border-radius: 16px;
        width: 75%;
        margin: 0 auto;
        margin-top: 66px;
        margin-bottom: 66px;
        color:#1d1d04; 
    }  
    .styling{
        border: 1px solid #8accd6;
        padding: 15px;
        border-radius: 5px;
        // width: 75%;
        margin: 0 auto;

    }
    .foodinput{
        margin-bottom: 30px !important;   
    }
    .subhead{
        color: #8accd6!important;
        font-size:12px;
        margin-bottom: 10   px;

    }  
    h4{
        // padding: 20px;
        color:#1f4349!important;
    }
    .submitbtn {
        margin:20px;
        color: #212529;
        background-color: #fbb800;
        border-color: #fbb800;
        border-radius: 50rem!important;
        width: 150px;
        justify-content: space-between;
        display:flex;
        align-items: center;
        padding:8px 12px;
    }
    .prevbtn {
        margin:20px;
        color: #212529;
        background-color: transparent;
        border-color: #848d9a;
        border-radius: 50rem!important;
        width: 150px;
        justify-content: space-between;
        display:flex;
        align-items: center;
        padding:8px 12px;


    }
    .btn-sec{
        display: flex;
        justify-content:center;
    }
    .select__control--is-focused{   
        border: 1px solid #dee2e6!important;
        box-shadow : unset;
    }
`
